import { useQueryClient } from '@tanstack/react-query'
import { useCallback } from 'react'
import { replyScheduleCalendarApiV1ReplyScheduleCalendarGetQueryKey } from '../gen/base'

export const useInvalidateReplyScheduleCalendarQuery = () => {
    const queryClient = useQueryClient()

    return useCallback(() => {
        queryClient.invalidateQueries({
            predicate: (query) =>
                query.queryKey.some(
                    (key) =>
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        //@ts-expect-error
                        key?.url ===
                        replyScheduleCalendarApiV1ReplyScheduleCalendarGetQueryKey()[0].url,
                ),
        })
    }, [queryClient])
}
